import DisabledProductPage from 'dashboard/components/DisabledProductPage';
import { DISABLED_CASES_ANALYTICS_PAGE } from 'dashboard/components/DisabledProductPage/config';
import InactiveEnvironmentBanner from 'dashboard/components/InactiveEnvironmentBanner';
import {
  RoutedTabbedSectionCard,
  RoutedTabbedSectionSwitch,
} from 'dashboard/components/TabbedSectionV2';
import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { productFeatureDisabled } from 'dashboard/lib/productFeature';
import { Environment } from 'dashboard/models/environment';
import { Organization, ProductFeatureName } from 'dashboard/models/organization';
import DashboardCaseAnalyticsProductivityRoute from 'dashboard/routes/DashboardCaseAnalyticsProductivityRoute';
import DashboardCaseAnalyticsResolutionsRoute from 'dashboard/routes/DashboardCaseAnalyticsResolutionsRoute';

export interface DashboardCaseAnalyticsViewProps {
  currentEnvironment: Environment;
  organization: Organization;
  hasCasesBasic: boolean;
  hasCasesEnhanced: boolean;
  hasCasesEnterprise: boolean;
}

const DashboardCaseAnalyticsView = ({
  currentEnvironment,
  organization,
  hasCasesBasic,
  hasCasesEnhanced,
  hasCasesEnterprise,
}: DashboardCaseAnalyticsViewProps) => {
  const productFeatureIsDisabled = productFeatureDisabled(
    organization,
    ProductFeatureName.CasesAnalytics,
    currentEnvironment.type,
  );

  if (
    productFeatureIsDisabled ||
    [hasCasesBasic, hasCasesEnhanced, hasCasesEnterprise].filter(Boolean).length === 0
  ) {
    return (
      <DisabledProductPage
        id={DISABLED_CASES_ANALYTICS_PAGE.id}
        title={DISABLED_CASES_ANALYTICS_PAGE.title}
        headerTitle={DISABLED_CASES_ANALYTICS_PAGE.headerTitle}
        description={DISABLED_CASES_ANALYTICS_PAGE.description}
        uses={DISABLED_CASES_ANALYTICS_PAGE.uses}
        image={DISABLED_CASES_ANALYTICS_PAGE.image}
      />
    );
  }

  return (
    <Container>
      <InactiveEnvironmentBanner />
      <Header title='Analytics' />
      <Section>
        <RoutedTabbedSectionCard
          tabs={[
            {
              name: 'Productivity',
              path: 'productivity',
              dataTest: 'case-analytics-view__tab--productivity',
            },
            {
              name: 'Resolutions',
              path: 'resolutions',
              dataTest: 'case-analytics-view__tab--resolutions',
            },
          ]}
        />
        <RoutedTabbedSectionSwitch
          tabs={[
            {
              path: 'productivity',
              contents: <DashboardCaseAnalyticsProductivityRoute />,
            },
            {
              path: 'resolutions',
              contents: <DashboardCaseAnalyticsResolutionsRoute />,
            },
          ]}
        />
      </Section>
    </Container>
  );
};

export default DashboardCaseAnalyticsView;
